import { normalizeList } from '../utils/apiUtils';

/**
 * Normalizes API permission payloads to an array of permission name strings.
 * Accepts: string[], { name }[], login body with permissions, etc.
 */
export const parsePermissionNames = (data) => {
  if (data == null) {
    return [];
  }

  if (Array.isArray(data)) {
    return data
      .map((item) => {
        if (typeof item === 'string') {
          return item.trim();
        }
        if (item && typeof item === 'object') {
          if (item.permission && typeof item.permission === 'object') {
            return (
              item.permission.name ??
              item.permission.permission_name ??
              item.permission.code ??
              null
            );
          }
          return item.name ?? item.permission_name ?? item.code ?? null;
        }
        return null;
      })
      .filter(Boolean);
  }

  if (typeof data === 'object') {
    if (Array.isArray(data.permissions)) {
      return parsePermissionNames(data.permissions);
    }
    if (Array.isArray(data.permission_names)) {
      return parsePermissionNames(data.permission_names);
    }

    const list = normalizeList(data);
    if (list.length > 0) {
      return parsePermissionNames(list);
    }
  }

  return [];
};
